import isFinite from 'lodash/isFinite';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('search', [
      'getConversionCurrency',
      'getConversionRate',
    ]),
  },

  methods: {
    convertCurrency(amount) {
      if (this.getConversionRate !== 1 && isFinite(Number(amount))) {
        return amount * this.getConversionRate;
      }

      return amount;
    },
  },
};
